<template>
  <v-container class="step">
    <v-row  justify="center" class="full-height width-8">
      <v-col class="m3-container">
        <div class="m3-content">
          <p class="m3-content-title"
            data-aos='fade-down'
            data-aos-delay="150"
            data-aos-duration="2000"
            data-aos-mirror="true"
            data-aos-once="false"
          >NMN</p>
          <div class="m3-content-main">
            <p class="m3-content-txt-1"
            data-aos='fade-down'
            data-aos-delay="150"
            data-aos-duration="2000"
            data-aos-mirror="true"
            data-aos-once="false"
            >{{$t('_material_2_txt_1')}}
              <br class="pc-show">{{$t('_material_2_txt_2')}}<br class="pc-show">{{$t('_material_2_txt_3')}}
            </p>
            <br />
            <p class="m3-content-txt-2"
              data-aos='fade-down'
              data-aos-delay="350"
              data-aos-duration="2000"
              data-aos-mirror="true"
              data-aos-once="false"
            >
            {{$t('_material_2_txt_4')}}
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style scoped>
.width-8 {
  padding-left: 10%;
  padding-right: 10%;
}
.m3-container {
  background-image: url("@/assets/image/renb_material_bg1.jpg");
  background-repeat: no-repeat, repeat;
  background-size: cover;
  background-position: center;
  height: 100%;
  width: 80%!important;
}
.m3-content {
  text-align: center;
}
.m3-content-title {
  font-family: "BodoniModa-Bold";
  color: #8d2022;
  font-size: 28px;
  font-weight: 600;
  margin-top: 10%;
}
.m3-content-txt-1 {
  font-family: "ZenKakuRegular";
  font-size: 13px;
  letter-spacing: 1.2px;
  line-height: 2;
  font-weight: 600;
  color: #481807;
  white-space: pre-line;
}
.m3-content-txt-2 {
  color: #481807;
  font-family: "ZenKakuRegular";
  font-size: 13px;
  letter-spacing: 1.2px;
  line-height: 2;
  font-weight: 600;
  white-space: pre-line;
}
.m3-content-main {
  width: 76%;
  margin: 10% auto;
  position: relative;
}
.pc-show {
  display: block;
}
@media (max-width: 960px) {
  .step {
    height: unset!important;
    scroll-snap-align:unset;
  }
  .full-height {
    height: 900px!important;
    width: 100%;
  }
  .width-8 {
    padding-left: unset;
    padding-right: unset;
  }
  .m3-content-main {
     width: 80%;
  }
  .pc-show {
    display: none;
  }
}
@media (max-width: 600px) {
  .m3-content {
    text-align: center;
  }
  .m3-content-main {
     width: 100%!important;
  }
  .m3-content-txt-1 {
    line-height: 2!important;
  }
  .m3-content-txt-2 {
    line-height: 2!important;
  }
}
@media (max-height:750px) {
  .m3-content-main {
    width: 80%;
    position: relative;
  }
  .m3-content-title {
    margin-top: 30px;
  }
  .m3-content-txt-1 {
    line-height: 1.8;
  }
  .m3-content-txt-2 {
    line-height: 1.8;
  }
  .m3-content-txt-1 {
    font-size: 12px;
  }
  .m3-content-txt-2 {
    font-size: 12px;
  }
}

</style>